<template>
  <div class="contentsBox">
    <input type="hidden" name="rel" :value="referrer" />
    <div class="messageBox" v-if="open">
      <img src="/img2022/titleH1.svg" width="380" alt="東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -" />
      <div class="errorMessage">
        <p class="error">502：Bad Gateway</p>
        <p class="error">申し訳ありません、何らかの原因によりサーバーに接続できません。</p>
      </div>
    </div>
  </div>
</template>
<script>
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  data () {
    return {
      referrer: '',
      open: false,
    }
  },
  created () {
    // 2022-12-09 18:30:54
    // Googleのモバイル検索インデックスに、なぜか、bad_gatewayページが写真展サイトのトップとして認識されてしまっているようなので
    // 強制的に転送する処理を入れた。リファラーがgoogleなら、トップページに遷移する
    this.referrer = document.referrer;
    if (this.referrer && (this.referrer.includes('https://www.google.co.jp/') || this.referrer.includes('https://www.google.com/'))) {
      // リファラーがGoogleだった場合、強制的に、トップページに書き換え
      location.href = process.env.VUE_APP_HOST
    } else {
      this.open = true
    }
  },
  methods: {
  },
  computed: {
  },
  mounted () {
  },
}
</script>

<style scoped>
.contentsBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.messageBox {
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.titleImg {
  margin: 0px 16px;
  display: block;
  max-width: 543;
  max-height: 56;
}

.errorMessage {
  margin: 32px;
}

.error {
  color: #ff0000;
}
</style>
